import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";

const PendingVerification = () => {
  const loans = [
    {
      id: "#10421",
      amount: "N250,000",
      repayment: "N285,000",
      applied: "08 - 04 - 2025",
      due: "20 - 07 - 2025",
      status: "Pending",
    },
    {
      id: "#10355",
      amount: "N1,450,000",
      repayment: "N1,600,000",
      applied: "02 - 04 - 2025",
      due: "20 - 07 - 2025",
      status: "Pending",
    },
    {
      id: "#10312",
      amount: "N48,250,000",
      repayment: "N48,500,000",
      applied: "22 - 03 - 2025",
      due: "20 - 08 - 2025",
      status: "Pending",
    },
    {
      id: "#10292",
      amount: "N800,000",
      repayment: "N950,000",
      applied: "17 - 03 - 2025",
      due: "20 - 06 - 2025",
      status: "Pending",
    },
    {
      id: "#10276",
      amount: "N20,000",
      repayment: "N30,000",
      applied: "16 - 03 - 2025",
      due: "20 - 06 - 2025",
      status: "Pending",
    },
    {
      id: "#10251",
      amount: "N55,000",
      repayment: "N65,000",
      applied: "06 - 03 - 2025",
      due: "20 - 06 - 2025",
      status: "Pending",
    },
    {
      id: "#10245",
      amount: "N1,650,000",
      repayment: "N1,800,000",
      applied: "28 - 02 - 2025",
      due: "20 - 05 - 2025",
      status: "Pending",
    },
  ];

  return (
    <div className="">
      {/* Search Bar */}
      <div className="mt-4">
        <input
          type="text"
          placeholder="Search by name"
          className="w-full border rounded-md p-2 text-sm"
        />
      </div>

      {/* Table */}
      <div className="overflow-x-auto mt-4">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-gray-100 text-gray-600">
            <tr>
              <th className="py-2 px-4">Name</th>
              <th className="py-2 px-4">User Type</th>
              <th className="py-2 px-4">Business Name</th>
              <th className="py-2 px-4">KYC Submission date</th>
              <th className="py-2 px-4">Status</th>
              <th className="py-2 px-4">Actions</th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {[].map((loan, idx) => (
              <tr key={idx} className="border-b hover:bg-gray-50">
                <td className="py-2 px-4">{loan.id}</td>
                <td className="py-2 px-4">{loan.amount}</td>
                <td className="py-2 px-4">{loan.repayment}</td>
                <td className="py-2 px-4">{loan.applied}</td>
                <td className="py-2 px-4">{loan.due}</td>
                <td className="py-2 px-4 flex items-center gap-2">
                  <span className="h-2 w-2 rounded-full bg-orange-400"></span>
                  {loan.status}
                </td>
                <td className="py-2 px-4 text-center">
                  <button className="bg-blue-100 text-blue-600 p-2 rounded-full">
                    <VisibilityIcon />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PendingVerification;
